import { PresetStatusColorType } from 'antd/lib/_util/colors';
import Tag from 'components/new-ui/base/tag/Tag';
import {
    ConsignmentId,
    ConsignmentList,
    ConsignmentName,
    ConsignmentRow,
} from 'views/declarations/common/ics2-message-details/styles';

export type ConsignmentStatus = {
    name: string;
    id: string;
    statusLabel: string;
    status: PresetStatusColorType;
};

type Props = {
    consignments: ConsignmentStatus[];
};

const ConsignmentStatusList = ({ consignments }: Props) => (
    <ConsignmentList>
        {consignments.map((consignment) => (
            <ConsignmentRow key={consignment.id}>
                <div>
                    <ConsignmentName>{consignment.name}</ConsignmentName>
                    <ConsignmentId>ID: {consignment.id}</ConsignmentId>
                </div>
                <Tag status={consignment.status} label={consignment.statusLabel} />
            </ConsignmentRow>
        ))}
    </ConsignmentList>
);

export default ConsignmentStatusList;
